import script from "./PageIntro.vue?vue&type=script&setup=true&lang=js"
export * from "./PageIntro.vue?vue&type=script&setup=true&lang=js"

import "./PageIntro.vue?vue&type=style&index=0&id=48c8886e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48c8886e"]])

export default __exports__